export const JobPositionVI = {
    "jobPosition": {
        "title": {
            "header": "Vị trí",
            "add": "Tạo mới vị trí",
            "update":"Cập nhật vị trí"
        },
        "columns": {
            "id": "ID",
            "name": "Tên",
            "order": "Thứ tự",
            "jobTitleName": "Chức vụ",
            "salaryMax": "Lương tối đa",
            "salaryMin": "Lương tối thiểu",
        }
    }
}